import React from "react";

const Loader = () => {
    return (
        <div className="loader">
            <div className="rect1" />
            <div className="rect2" />
            <div className="rect3" />
            <div className="rect4" />
            <div className="rect5" />
        </div>
    );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/Loader.js